/**
 * Created by fers on 27.04.16.
 */
import React from 'react';
import PropTypes from 'prop-types';
import {ParentBox, relayWrap} from '../../box-utils/ParentBox.react.js';
import {viewWithDataGetPrimaryData} from '../../box-utils/PrimaryData';
import Error from '../system/Error.react.js';
import {sendError} from '../../../app/errorDisplayer';
import BoxDecorator from '../../box-utils/BoxDecorator.react';
import {joinedEvaluateExpression} from '../../../../common/expression/ExpressionBuilder';
import './IFrame.scss';
import {safeJSONparse} from "../../../../common/util/safeJSONparse";

class IFrame extends ParentBox {

    static handlerName = "iframe";

    static propTypes = {
        isPreview: PropTypes.bool,
        viewWithData: PropTypes.object.isRequired,
    };

    getIcon() {
        return "dativery";
    }

	getServiceName() {
		return "Dativery";
	}

    render() {
        let data = this.props.viewWithData.data;
        data = viewWithDataGetPrimaryData(data);

        let channelAddon = this.props.viewWithData.view.channelAddon;
        let options = {};

        if (channelAddon && channelAddon.options) {
            options = safeJSONparse(channelAddon.options);
        }

        let row = {};
        let url = null;

        if (data.length > 0 && options.url) {
            row = data[0];

            url = joinedEvaluateExpression(options.url, (varName) => {
                return row[varName];
            });
        }

        try {
            return (
                <BoxDecorator className="dativeryIframeBox" icon={this.getIcon()} isPreview={this.props.isPreview} title={this.getServiceName()}>
                    <div><small><strong className="box-app-iframe-title ">{channelAddon ? (channelAddon.name ? channelAddon.name : channelAddon.addonDef.name) : null}</strong> &nbsp; <small><a href={url} target="_blank"><span className="fa fa-search"></span></a></small></small></div>

                    {this.props.isPreview || !url ?
                        <div className="box-app-iframe-placeholder"></div>
                        :
                        <iframe className="box-app-iframe" frameBorder={0} height={options.height ? options.height : "100%"} seamless
                                src={url} width="100%">
                        </iframe>
                    }
                </BoxDecorator>
            );
        } catch (e) {
            sendError(e);
            return (<Error error={e} />);
        }
    }
}

export default relayWrap(IFrame);
